import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';

export const isNative = () => Capacitor.isNativePlatform();
export const platform = () => Capacitor.getPlatform();

// Public web origin (the backend + web app share a domain). In the native shell
// window.location.origin is https://localhost, so Stripe/gift links must use this.
export const webOrigin = () =>
  isNative() ? process.env.REACT_APP_BACKEND_URL : window.location.origin;

// Stripe checkout / portal: in-app browser on native, plain redirect on web.
export async function openExternal(url, { checkout = false } = {}) {
  if (!isNative()) { window.location.href = url; return; }
  if (checkout) sessionStorage.setItem('unmanip_checkout_pending', '1');
  await Browser.open({ url, presentationStyle: 'popover', toolbarColor: '#09090b' });
}

export function initNative(navigate) {
  if (!isNative()) return () => {};
  import('@/lib/push').then(m => m.listenPushTaps(navigate)).catch(() => {});
  import('@/lib/guard').then(m => m.guardSync()).catch(() => {});
  StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
  if (platform() === 'android') StatusBar.setBackgroundColor({ color: '#09090b' }).catch(() => {});
  SplashScreen.hide().catch(() => {});

  const back = App.addListener('backButton', ({ canGoBack }) => {
    if (window.location.pathname === '/' || !canGoBack) App.exitApp();
    else window.history.back();
  });

  const resume = App.addListener('appStateChange', ({ isActive }) => {
    if (!isActive) return;
    window.dispatchEvent(new Event('unmanip:resume'));
    if (sessionStorage.getItem('unmanip_checkout_pending')) {
      sessionStorage.removeItem('unmanip_checkout_pending');
      Browser.close().catch(() => {});
      navigate('/credits?refresh=1', { replace: true });
      window.dispatchEvent(new Event('unmanip:credits-refresh'));
    }
  });

  return () => { back.then(h => h.remove()); resume.then(h => h.remove()); };
}
